/**
 * Product card color variations (linked products)
 *
 * The store registers each color as a separate product, linked together with the
 * custom.variation_products / custom.variation_value metafields (same mechanism as the
 * "product_variations" block on the product page). The theme's built-in card swatch
 * behavior only handles variants of a single product, so this script handles the
 * linked-products case:
 *
 * - Clicking a swatch swaps the card image (primary + hover image) to the linked product's images
 * - The card links (image + title) are updated to point to the linked product
 * - Clicking the already selected swatch navigates to that product page
 */
(function () {
  'use strict';

  function replaceImage(imageElement, src, srcset, alt) {
    if (!imageElement || !src) return Promise.resolve(null);

    var newImage = imageElement.cloneNode(false);
    newImage.removeAttribute('width');
    newImage.removeAttribute('height');
    newImage.removeAttribute('srcset');
    newImage.src = src;
    if (srcset) newImage.setAttribute('srcset', srcset);
    newImage.alt = alt || '';

    return new Promise(function (resolve) {
      if (newImage.complete) {
        resolve(newImage);
      } else {
        newImage.onload = function () { resolve(newImage); };
        newImage.onerror = function () { resolve(null); };
      }
    });
  }

  document.addEventListener('click', function (event) {
    var swatchLink = event.target.closest('[data-variation-swatch] a');
    if (!swatchLink) return;

    var card = swatchLink.closest('product-card');
    if (!card) return;

    // Second click on the selected swatch follows the link to the product page
    if (swatchLink.classList.contains('is-selected')) return;

    event.preventDefault();

    var wrapper = swatchLink.closest('[data-variation-swatch]');
    var url = wrapper.getAttribute('data-variation-url');

    card.querySelectorAll('[data-product-variations] a').forEach(function (link) {
      link.classList.remove('is-selected');
    });
    swatchLink.classList.add('is-selected');

    if (url) {
      var mediaLink = card.querySelector('a.product-card__media');
      var titleLink = card.querySelector('a.product-title');
      if (mediaLink) mediaLink.href = url;
      if (titleLink) titleLink.href = url;

      var title = wrapper.getAttribute('data-variation-title');
      if (titleLink && title) titleLink.textContent = title;
    }

    var primary = card.querySelector('.product-card__image--primary');
    var secondary = card.querySelector('.product-card__image--secondary');

    // Swap the hover (secondary) image without animation
    if (secondary) {
      var secondarySrc = wrapper.getAttribute('data-secondary-media-src');

      if (secondarySrc) {
        replaceImage(secondary, secondarySrc, wrapper.getAttribute('data-secondary-media-srcset'), '').then(function (newSecondary) {
          if (newSecondary) secondary.replaceWith(newSecondary);
        });
      } else {
        // The linked product has a single image: hide the stale hover image
        secondary.remove();
      }
    }

    // Swap the primary image with a fade, once the new image is loaded
    if (primary && wrapper.getAttribute('data-media-src')) {
      if (primary.src === wrapper.getAttribute('data-media-src')) return;

      var fadeOut = primary.animate({ opacity: [1, 0] }, { duration: 150, easing: 'ease-in', fill: 'forwards' });
      var newImagePromise = replaceImage(primary, wrapper.getAttribute('data-media-src'), wrapper.getAttribute('data-media-srcset'), wrapper.getAttribute('data-media-alt'));

      Promise.all([fadeOut.finished, newImagePromise]).then(function (results) {
        var newImage = results[1];

        if (newImage) {
          primary.replaceWith(newImage);
          newImage.animate({ opacity: [0, 1] }, { duration: 150, easing: 'ease-in' });
        } else {
          primary.animate({ opacity: [0, 1] }, { duration: 150, easing: 'ease-in', fill: 'forwards' });
        }
      });
    }
  });
})();
